import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
}

const IconSearchUi: React.FC<IProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...props}
        >
            <path
                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.0009 19L15.7109 15.71" stroke="white" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
        </svg>

    );
};

export default IconSearchUi;